var map = {
	"./addTestBlind.svg": 96237,
	"./arrow.svg": 58415,
	"./bold.svg": 28524,
	"./cloud.svg": 41811,
	"./comments.svg": 44102,
	"./delete.svg": 66516,
	"./discard.svg": 26996,
	"./ellipse.svg": 52681,
	"./filter.svg": 7186,
	"./format.svg": 9382,
	"./highlight.svg": 57915,
	"./history.svg": 37550,
	"./italic.svg": 27300,
	"./line.svg": 74297,
	"./link.svg": 81423,
	"./mask.svg": 56742,
	"./padlock-locked.svg": 37280,
	"./padlock-unlocked.svg": 39012,
	"./polyline.svg": 31703,
	"./rectangle.svg": 56729,
	"./redo.svg": 15215,
	"./save.svg": 65421,
	"./screenshot.svg": 98195,
	"./shapes.svg": 47033,
	"./stamp.svg": 82194,
	"./symbol.svg": 14205,
	"./text.svg": 74424,
	"./thumbnail.svg": 87020,
	"./undo.svg": 48614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80766;